import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Game from './views/Game.vue'
import GameScore from './views/GameScore.vue'
import RecordedArrows from "./views/RecordedArrows";

Vue.use(Router)

export default new Router({
    //mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/game',
            name: 'game',
            component: Game
        },
        {
            path: '/game-score',
            name: 'game-score',
            component: GameScore
        },
        {
            path: '/recorded-arrows',
            name: 'recorded-arrows',
            component: RecordedArrows
        }
    ]
})
